<template>
    <div class="header-dots">

      <!--
      <button type="button" class="p-0 mr-2 btn btn-link" @click="notificationExample()">
                <span class="icon-wrapper icon-wrapper-alt rounded-circle">
                    <span class="icon-wrapper-bg bg-danger"></span>
                    <i class="icon text-danger ion-android-notifications"></i>
                     <i class="icon text-danger icon-anim-pulse ion-android-notifications"></i>
                    <span class="badge badge-dot badge-dot-sm badge-danger" style="z-index: 5">Notifications</span>
                </span>
        </button>
      -->

    </div>

</template>

<script>

    export default {
      name: "t-app-notification",
      methods: {
        setLang(type){
          this.$translate.setLang(type)
        },
        notificationExample(){
          this.$bvModal.msgBoxOk("Não há nenhuma notificação pendente no momento!", {
            title: "Notificações",
            okVariant: 'primary',
            okTitle: 'Ok',
            hideHeaderClose: false,
          }).then(() => {


          })
        }
      },

    }
</script>

<style scoped>
.icon-wrapper-bg{
  background-color: #fbe9ed !important;
  opacity: 1 !important;
}
button:hover .icon-wrapper-bg{
  background-color: #ffcbda !important;
}
</style>
